<template>
    <div class="relatorio-analitico">
        <RelatorioAnaliticoComponentList
            app_modulo="promotor"
            app_submodulo="relatorio-analitico"
            app_tela="relatorio-faturamento"
            :objectList="faturamentoList"
            :objectListAll="faturamentoListAll"
            :isEmpty="isEmpty"
            :isLoading="isLoading"
            :isDataStarted="isDataStarted"
            :pagination="pagination"
            :tooltipLabelSearch="
                $t('msg-campo-busca-n', {
                    n: `${$t('rsocial')} e ${$t('nome')} (${$t('cliente')} e ${$t('lps')}) e ${$t('lps_estado')}`,
                })
            "
            showLateralFilter
            :cameFrom="cameFrom"
            @filtersReset="filtersReset = $event"
            @loadedFiels="loadedFiels = $event"
            @carregarDados="carregarDados($event)"
            @carregarDadosExportAll="carregarDados($event, true)"
            @search="onSearch($event)"
            @clearFilter="clearFilter()"
            @orderColumn="pagination.orderColumn = $event"
            @orderDirection="pagination.orderDirection = $event"
            @perPage="pagination.perPage = $event"
            @currentPage="pagination.currentPage = $event"
            @isLoading="isLoading = $event"
            @voltar="$emit('voltar', $event)"
        >
            <template v-slot:top-filter>
                <vss-select
                    title="empresa"
                    ref="empresaSelect"
                    class="smaller"
                    :value="empresaSelected"
                    :options="empresaList"
                    :height="40"
                    :loading="empresaLoading"
                    @search="carregarEmpresas"
                    @input="updateEmpresa"
                    label="rsocial"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
                <vss-select
                    title="colaborador"
                    ref="colaboradorSelect"
                    class="smaller"
                    :value="colaboradorSelected"
                    :options="colaboradorList"
                    :height="40"
                    :loading="colaboradorLoading"
                    @search="carregarColaboradores"
                    @input="updateColaborador"
                    label="nome"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                    tooltipLabel="msg-associacao-empresa-colaborador"
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
            </template>

            <template v-slot:table-column="{ props, field }">
                <div 
                    v-if="field.key === 'resultado'"
                    :class="{ 
                        'is-text-color-success': props.row.resultadoNumerico > 0,
                        'is-text-color-danger': props.row.resultadoNumerico < 0
                    }"
                >
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
                <div v-else>
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
            </template>

            <template v-slot:lateral-filter>
                <FiltroProFaturamento
                    ref="filtroRef"
                    :filtersReset="filtersReset"
                    @update-filtro="updateFiltro"
                />
            </template>
        </RelatorioAnaliticoComponentList>
    </div>
</template>

<script>
import RelatorioAnaliticoComponentList from '@/components/shared/tela/RelatorioAnaliticoComponentList.vue';
import FiltroProFaturamento from '@/components/promotor/relatorio-analitico/relatorio-faturamento/RelatorioFaturamentoListFiltro.vue';
import LateralContentFoto from '@/components/shared/tela/LateralContentFoto.vue';

export default {
    components: {
        RelatorioAnaliticoComponentList,
        FiltroProFaturamento,
        LateralContentFoto
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            faturamentoList: [],
            faturamentoListAll: [],

            filtros: {
                idEmpresaList: [],
                idColaboradorList: [],
                dataInicial: new Date(this.$moment().subtract(30, 'days')),
                dataFinal: new Date(),
                idLpsList: [],
                idClienteList: [],
                idLpsList: [],
                idBandeiraList: [],
                idRedeList: [],
                idCidadeList: [],
                idTipoServicoList: [],
                idCargoList: [],
                agrupaPorLps: false
            },

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                orderColumn: 'idlpserp',
                orderDirection: 'asc',
                queryFilter: '.*',
            },

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            isLoading: false,
            loadedFiels: false,

            isEmpty: true,
            filtersReset: false,

            isDataStarted: false,
        };
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        onSearch(value) {
            this.pagination.queryFilter = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1, getAll = false) {
            if (!getAll && currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            if (!getAll) this.faturamentoListAll = [];

            this.isLoading = true;
            this.$axios
                .post(`pro/relatorio/faturamento/list.json`, this.filtros, {
                    params: {
                        column: this.pagination.orderColumn,
                        order: this.pagination.orderDirection,
                        page: currentPage - 1,
                        limit: getAll ? this.pagination.totalRows : this.pagination.perPage,
                        search: this.pagination.queryFilter,
                    },
                })
                .then((response) => {
                    if (!getAll) {
                        this.isEmpty = response.data.totalElements == 0;
                        this.pagination.totalRows = response.data.totalElements;
                    }

                    return response.data.content.map((obj) => {
                        return {
                            ...obj,
                            cliente_situacao:
                                obj.cliente_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                            lps_situacao: obj.lps_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                            data_execucao: this.$moment(obj.data_execucao).format('L'),
                            valor_custo: !this.isNull(obj.valor_custo) ? this.parseAsCurrency(obj.valor_custo) : obj.valor_custo,
                            valor_cobrado: !this.isNull(obj.valor_cobrado) ? this.parseAsCurrency(obj.valor_cobrado) : obj.valor_cobrado,
                            resultado: !this.isNull(obj.resultado) ? this.parseAsCurrency(obj.resultado) : obj.resultado,
                            resultadoNumerico: obj.resultado,
                            valor_total_custo: !this.isNull(obj.valor_total_custo) ? this.parseAsCurrency(obj.valor_total_custo) : obj.valor_total_custo,
                            valor_total_cobrado: !this.isNull(obj.valor_total_cobrado) ? this.parseAsCurrency(obj.valor_total_cobrado) : obj.valor_total_cobrado,
                        };
                    });
                })
                .then((mappedContent) => {
                    if (getAll) {
                        this.faturamentoListAll = mappedContent;
                    } else {
                        this.faturamentoList = mappedContent;
                    }
                })
                .catch((exception) => {
                    console.error('Erro ao carregar faturamento.', exception);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isDataStarted = true;
                    if (this.loadedFiels) this.isLoading = false;
                });
        },
        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa/list.json?param=${search}`)
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[FATURAMENTO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.empresaList = response.data.content.map((e) => {
                            return {
                                id: e.idempresa,
                                rsocial: e.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[FATURAMENTO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.idEmpresaList =
                this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(search = '') {
            this.colaboradorLoading = true;

            const empresa =
                this.empresaSelected.length > 0 ? this.empresaSelected.map((e) => e.id) : [];

            this.$axios
                .post(`/employees/list/associacaoidsempresa.json?search=${search}`, empresa)
                .then((response) => {
                    if (response.status != 200) {
                        console.error(
                            `[FATURAMENTO] Erro status ${r.status} ao carregar colaboradores.`
                        );
                        console.error(`[FATURAMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.colaboradorList = response.data.content;
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[FATURAMENTO] Erro ao carregar colaboradores.', e);
                })
                .finally((f) => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;

            this.filtros.idColaboradorList =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);

            this.carregarDados();
        },
        clearFilter() {
            this.pagination.queryFilter = '.*';
            
            this.filtros.idEmpresaList = [];
            this.empresaSelected = [];

            this.filtros.idColaboradorList = [];
            this.colaboradorSelected = [];

            this.filtros.dataInicial = new Date(this.$moment().subtract(30, 'days'))
            this.filtros.dataFinal = new Date()
            this.filtros.idLpsList = []
            this.filtros.idClienteList = []
            this.filtros.idLpsList = []
            this.filtros.idBandeiraList = []
            this.filtros.idRedeList = []
            this.filtros.idCidadeList = []
            this.filtros.idTipoServicoList = []
            this.filtros.idCargoList = []
            this.filtros.agrupaPorLps = false

            setTimeout(() => {
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
    },
};
</script>

<style lang="scss" scoped>
.relatorio-analitico {
    height: 100%;
}
</style>